module.exports = __webpack_public_path__ + "static/media/A7S01705.53db3fda.jpg";